<template>
  <div>
    <div class="w-full h-full">
      <div class="text-center text-3xl" v-show="loading">Loading...</div>
      <img v-show="!loading" class="mx-auto w-full h-full" ref="image" src="" />
    </div>
  </div>
</template>

<script>
import photo from "../../mixins/photo";

export default {
  name: "Slideshow",
  components: {},
  mixins: [photo],
  data() {
    return {
      photos: [],
      current: 0,
      interval: 5,
      loading: true,
    };
  },
  methods: {
    init() {
      setInterval(() => {
        this.$refs.image.src = this.photos[this.current];
        this.current++;
        if (this.current > this.photos.length - 1) {
          this.current = 0;
        }
      }, this.interval * 1000);
    },
  },
  mounted() {
    this.$store
      .dispatch("slideshows/get_slideshow", this.$route.params.slideshowId)
      .then((resp) => {
        if (!resp.success) {
          this.$notify({
            title: "Slideshow",
            message: "Unable to load slideshow",
            type: "danger",
          });
          return;
        }
        resp.slideshow.photos.forEach((photo) => {
          // let image = new Image();
          // image.src = photo.full_path;
          this.photos.push(
            this.getS3Photo(photo.path, photo.file_name, 1000, 1000, 60, true)
          );
        });
        this.interval = resp.slideshow.interval;
        this.init();
        setTimeout(() => {
          this.loading = false;
        }, this.interval * 1000);
      });
  },
};
</script>
